function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.98 19.38h1.04c1.59 0 2.23-.6 2.23-2.12V5.38h-5.5v11.88c.01 1.52.65 2.12 2.23 2.12z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M7.48 14.38h1.04c1.59 0 2.23-.61 2.23-2.12V5.38h-5.5v6.88c.01 1.51.65 2.12 2.23 2.12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.25 6.12H2.75c-.41 0-.75-.33-.75-.74s.34-.75.75-.75h18.5c.41 0 .75.34.75.75s-.34.74-.75.74z"
})));